
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

@Component({
  selector: 'soft-pms-task-drag-card',
  templateUrl: './pms-task-drag-card.component.html',
  styleUrls: ['./pms-task-drag-card.component.css'],
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PmsTaskDragCardComponent {
  constructor() {
    //
  }

  bgColor = input<string>('bg-primary');
  headTextColor = input<string>('text-primary');

  scheduled = input<boolean>(false);

  headText = input<string>('Tätigkeit id');
  title = input<string>('0000 - Softline');
  description = input<string>();
  description2 = input<string>();
  description3 = input<string>();
  description4 = input<string>();
}
